import {
    type GenerationStatus,
    type GenerationStepStatus,
    generatorStepsConfig,
    getStepStatus,
} from '@/entities/session';
import { StatusIcon } from '@/shared/ui/common/status-icon';

interface Props {
    currentStep: GenerationStatus;
}

interface StepItemProps {
    label: string;
    status: GenerationStepStatus;
}

function StepItem({ label, status }: StepItemProps) {
    const iconStatus = status === 'in_progress' ? 'in-progress' : status;
    return (
        <div className="flex items-center gap-2 px-2 py-1">
            <StatusIcon status={iconStatus} />
            <span className="text-foreground">{label}</span>
        </div>
    );
}

export function TodaySessionsItemGenerationSteps({ currentStep }: Props) {
    return (
        <div className="flex pl-2 pb-2">
            <div className="border-sidebar-border border-l ml-4">
                {generatorStepsConfig.map((step) => {
                    const status = getStepStatus(step.key, currentStep);
                    return <StepItem key={step.key} label={step.label} status={status} />;
                })}
            </div>
        </div>
    );
}
